<template>
  <div class="home-banner-middle image-fit" v-if="landingPage.hex_bg">
    <img :src="landingPage.hex_bg" alt />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
  name: "LandingBannerMiddle",
  computed: {
    ...mapState({
      landingPage: state => get(state, "app.landingPage")
    })
  }
};
</script>
